export interface HeatmapCell {
  dayOfWeek: number
  hour: number
  /** All calls in this cell (voice agent + human). */
  calls: number
  /** Voice agent (BLANDAI) calls in this cell. */
  voiceAgentCalls: number
  /** Human (employee) calls in this cell. */
  humanCalls: number
  /** Non-cancelled bookings attached to calls in this cell (agent-only). */
  bookings: number
}

export interface HeatmapSummary {
  totalCalls: number
  offHoursCalls: number
  voiceAgentCalls: number
  offHoursVoiceAgentCalls: number
  humanCalls: number
  offHoursHumanCalls: number
  totalBookings: number
  offHoursBookings: number
}

export const CALL_COVERAGE_INFO_TEXT =
  'Calls by local hour and weekday, following the filters above. The coverage rows split each group — all calls, employee calls, and voice agent calls — into staffed vs off-hours. Staffed hours: Mon–Fri 9am–5pm; everything outside is the off-hours window the voice agent covers.'

// Mon-first row order so the Mon–Fri staffed band reads as one contiguous
// block; Postgres DOW convention (0 = Sunday).
export const DAY_ORDER = [1, 2, 3, 4, 5, 6, 0]

export const DAY_LABELS: Record<number, string> = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
}

export const HOURS = Array.from({ length: 24 }, (_, h) => h)

export const hourLabel = (hour: number): string => {
  if (hour === 0) return '12am'
  if (hour < 12) return `${hour}am`
  if (hour === 12) return '12pm'
  return `${hour - 12}pm`
}
